@if (!showingAll && !loading && features && features[selectedIndex]) {
  <div class="image-only-announcement">
    <button class="image-only-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
      <fa-icon icon="times"></fa-icon>
    </button>
    @if (isCurrentImageOnly) {
      @if (features[selectedIndex].image_link) {
        <a [href]="features[selectedIndex].image_link" style="width: 100%" target="_blank">
          <img [src]="features[selectedIndex].image_url" class="image-only-img" />
        </a>
      } @else {
        <img [src]="features[selectedIndex].image_url" class="image-only-img" />
      }
    } @else {
      <div class="w-full">
        @if (features[selectedIndex].title) {
          <fui-heading [text]="features[selectedIndex].title" [level]="2"></fui-heading>
        }
        <span class="t-14 d-block m-b-10">{{ features[selectedIndex].date.toDate() | date }}</span>
        @if (features[selectedIndex].image_url) {
          @if (features[selectedIndex].image_link) {
            <a [href]="features[selectedIndex].image_link" style="width: 100%" target="_blank">
              <img [src]="features[selectedIndex].image_url" style="max-width: 1000px; width: 100%; border-radius: 8px; cursor: pointer" class="m-b-15" />
            </a>
          } @else {
            <img [src]="features[selectedIndex].image_url" style="max-width: 1000px; width: 100%; border-radius: 8px" class="m-b-15" />
          }
        }
        @if (sanitizedDescription) {
          <div class="quill-content" [innerHTML]="sanitizedDescription | safe: 'html'"></div>
        }
      </div>
    }
    @if (features.length > 1) {
      <myp-paginator
        [offset]="selectedIndex + 1"
        [totalPages]="features.length"
        [limit]="1"
        [resultsLength]="1"
        [hasNext]="selectedIndex + 1 < features.length"
        [async]="false"
        [paginate]="paginate"
      ></myp-paginator>
    }
  </div>
} @else if (showingAll) {
  <div class="image-only-announcement">
    <button class="image-only-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
      <fa-icon icon="times"></fa-icon>
    </button>
    <myp-inline-loader [loading]="loading" height="400px" spinnerName="announcementsLoader"></myp-inline-loader>

    @if (!loading && (!features || !features.length)) {
      <div class="m-y-20">{{ "feature_updates.no_new_announcements" | translate }}</div>
    }

    @if (!selectedAnnouncement) {
      <ul class="list-group" style="width: 100%">
        @for (ann of features; track ann) {
          <li class="list-group-item p-0 border-0 bg-transparent">
            <div role="button" aria-label="announcement">
              <myp-list-item [title]="ann.title" [subData]="[ann.date.toDate() | date]" [showImage]="false" (itemClicked)="selectAnnouncement(ann)"></myp-list-item>
            </div>
          </li>
        }
      </ul>
    }
    @if (selectedAnnouncement) {
      <div class="w-full">
        <div class="back-container gothic m-b-20">
          <button type="button" class="btn btn-transparent p-0 m-r-10" (click)="selectedAnnouncement = undefined" aria-label="back">
            <fa-icon icon="arrow-left" class="circle-icon-btn" aria-hidden="true" style="font-size: 1rem"></fa-icon>
            <span class="sr-only">{{ "feature_updates.back" | translate }}</span>
          </button>
          <h6 class="m-b-0">{{ "feature_updates.announcements" | translate }}</h6>
        </div>
        @if (selectedAnnouncement.title) {
          <fui-heading [text]="selectedAnnouncement.title" [level]="2"></fui-heading>
        }
        <span class="t-14 d-block m-b-10">{{ selectedAnnouncementDate | date }}</span>
        @if (selectedAnnouncement.image_url) {
          @if (selectedAnnouncement.image_link) {
            <a [href]="selectedAnnouncement.image_link" style="width: 100%" target="_blank">
              <img [src]="selectedAnnouncement.image_url" style="max-width: 1000px; width: 100%; border-radius: 8px; cursor: pointer" class="m-b-15" />
            </a>
          } @else {
            <img [src]="selectedAnnouncement.image_url" style="max-width: 1000px; width: 100%; border-radius: 8px" class="m-b-15" />
          }
        }
        @if (sanitizedDescription) {
          <div class="quill-content" [innerHTML]="sanitizedDescription | safe: 'html'"></div>
        }
      </div>
    }
  </div>
}
